<template>
  <div
    v-if="notices && notices.length > 0"
    style="background-color: black; padding: 8px 8px; border-radius: 6px;  margin-top: 5px;"
  >
    <small class="text-white font-weight-bold d-block mb-0">📢 Notice</small>
    <ul class="mb-0 pl-2">
      <li
        v-for="(notice, index) in notices"
        :key="index"
        style="font-size: 14px; color: white;"
      >
        {{ notice }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NoticeWrapper',
  props: {
    notices: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
